import { Badge as InterstateBadge } from '@interstate/components/Badge';
import { Box } from '@interstate/components/Box';
import type { BadgeProps } from '../../types/AuditLog';

const Badge: React.FC<BadgeProps> = ({ children, variant }) => {
    return (
        <Box display="flex">
            <InterstateBadge variant={variant}>{children}</InterstateBadge>
        </Box>
    );
};

export default Badge;
